module.exports = __webpack_public_path__ + "static/media/bg-6.d80340fd.png";